import { TenantFormData, ApplicationSubscription } from '../types/tenant';

export const safeParseFloat = (value: string | number): number => {
  if (typeof value === 'number') return value;
  if (!value || value === '') return 0;
  const parsed = parseFloat(String(value));
  return isNaN(parsed) ? 0 : parsed;
};

export const safeParseInt = (value: string | number): number => {
  if (typeof value === 'number') return Math.round(value);
  if (!value || value === '') return 1;
  const parsed = parseInt(String(value), 10);
  return isNaN(parsed) ? 1 : parsed;
};

export const formatTenantName = (name: string): string => {
  return name.toLowerCase().trim().replace(/[^a-zA-Z0-9]/g, '-');
};

export const processFormData = (formData: TenantFormData): TenantFormData => {
  formData.name = formatTenantName(formData?.name || '');

  if (formData.location) {
    formData.location.latitude = safeParseFloat(formData.location.latitude);
    formData.location.longitude = safeParseFloat(formData.location.longitude);
    formData.location.zoom = safeParseFloat(formData.location.zoom);
  }

  if (formData.applicationSubscriptions) {
    formData.applicationSubscriptions = formData.applicationSubscriptions.map(subscription => ({
      ...subscription,
      features: subscription.features || []
    }));
  }

  if (formData.publicWaterSystems) {
    formData.publicWaterSystems = formData.publicWaterSystems.filter(pws =>
      pws.pwsId && pws.pwsId.trim() !== ''
    );
  }

  if (formData.contacts) {
    formData.contacts = formData.contacts.filter(contact =>
      contact.name && contact.name.trim() !== ''
    );
  }

  if (formData.tags) {
    formData.tags = formData.tags.filter(tag =>
      tag.name && tag.name.trim() !== ''
    );
  }

  if (formData.aliases) {
    formData.aliases = formData.aliases.filter(alias =>
      alias.alias && alias.alias.trim() !== ''
    );
  }

  return formData;
};

export const validateApplicationSubscriptions = (subscriptions: ApplicationSubscription[]): boolean => {
  return subscriptions && subscriptions.length > 0;
};
